import $ from "jquery";

if (document.querySelector(".slideOfCardsWithGradient__slide")) {

    const slidergridproduct = document.querySelectorAll(".slideOfCardsWithGradient__slide");

    slidergridproduct.forEach(cardSlider => {
        $(cardSlider).slick({
            dots: true,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 2,
            arrows: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },]

        });
    });
}